import { gql, useQuery } from "@apollo/client";
import React, { useRef, useState } from "react";
import { Toast } from "src/hooks/toast";
import { BreadCrumb, BreadCrumbProp } from "../../components/light/Breadcrumb";
import { Content } from "../../components/light/Content";
import { SectionBlock } from "../../components/light/SectionBlock";
import { Loading } from "../../components/Loading";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import { PaginationOffset } from "src/components/pagination/PaginationOffset";

const BreadCrumbItems: BreadCrumbProp[] = [
  {
    text: "Dashboard",
    to: "/",
  },
  {
    text: "FBL Center",
    to: "/dashboard/fbl",
  },
];

const QUERY = gql`
  query merchantInventoryFBL(
    $offset: Int = 0
    $limit: Int = 30
    $filter: FilterFbl
  ) {
    merchantInventoryFBL(offset: $offset, limit: $limit, filter: $filter)
  }
`;

const MERCHANT_BRAND_LIST = gql`
  query merchantBrandList($status: Int = 1) {
    merchantBrandList(status: $status) {
      id
      alias
      name
      banner
      picture
      description
      status
    }
  }
`;

const SUPPLIER_VENDOR_LIST = gql`
  query supplierVendorList {
    supplierVendorList {
      id
      name
      contactInfo
      address
      note
      margin
    }
  }
`;

export function FBLCenterScreen(props: any) {
  const inputRef = useRef<HTMLInputElement | null>(null);

  const [sku, setSku] = useState([]);
  const [offset, setOffset] = useState(0);
  const [search, setSearch] = useState("");
  const [show, setShow] = useState(false);
  const [brandSelect, setBrandSelect] = useState<
    { value: number; label: string }[]
  >([]);
  const [vendorSelect, setVendorSelect] = useState<
    { value: number; label: string }[]
  >([]);

  const brand = useQuery(MERCHANT_BRAND_LIST);
  const vendor = useQuery(SUPPLIER_VENDOR_LIST);
  const { data, loading } = useQuery(QUERY, {
    variables: {
      offset: offset * 30,
      limit: 30,
      filter: {
        search,
        brand:
          brandSelect.length === 0
            ? undefined
            : brandSelect.map((x) => Number(x.value)),
        vendor:
          vendorSelect.length === 0
            ? undefined
            : vendorSelect.map((x) => Number(x.value)),
      },
    },
    onCompleted: (res) => {
      if (res.merchantInventoryFBL.length === 0) {
        // setOffset(0);
        Toast.onShow("next page no data...", "info", "right");
      }
    },
  });

  if (loading || data === undefined) {
    return (
      <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
        <div className="row">
          <div className="col-md-12">
            <SectionBlock title="Inventory FBL Center">
              <div className="row">
                <div className="col">
                  <nav className="text-center">
                    <PaginationOffset
                      {...props}
                      onPage={(p: any) => setOffset(p - 1)}
                    />
                  </nav>
                </div>
                <div className="col">
                  <Select
                    isMulti
                    classNamePrefix="form-control"
                    value={brandSelect}
                    options={
                      brand.data === undefined
                        ? []
                        : brand.data.merchantBrandList?.map((x: any) => {
                            return { value: x.id, label: x.name };
                          })
                    }
                    onChange={(e: any) => setBrandSelect(e ? e : [])}
                  />
                </div>
                <div className="col">
                  <Select
                    isMulti
                    classNamePrefix="form-control"
                    value={vendorSelect}
                    options={
                      vendor.data === undefined
                        ? []
                        : vendor.data.supplierVendorList?.map((x: any) => {
                            return { value: x.id, label: x.name };
                          })
                    }
                    onChange={(e: any) => setVendorSelect(e ? e : [])}
                  />
                </div>
                <div className="col">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="search..."
                    ref={inputRef}
                    onBlur={() => {
                      setSearch(inputRef.current!.value);
                    }}
                    onKeyDown={(e) =>
                      e.key === "Enter" && setSearch(inputRef.current!.value)
                    }
                  />
                </div>
              </div>
              <table className="table table-bordered table-striped dataTable">
                <thead>
                  <tr>
                    <th className="text-center">No.</th>
                    <th className="text-center">Image</th>
                    <th className="text-center">Code</th>
                    <th className="text-center" style={{ width: 75 }}>
                      Colors
                    </th>
                    <th className="text-center" style={{ width: 75 }}>
                      Size
                    </th>
                    <th className="text-center" style={{ width: 75 }}>
                      Stock
                    </th>
                    <th className="text-center" style={{ width: 75 }}>
                      Price
                    </th>
                    <th className="text-center" style={{ width: 75 }}>
                      Discount
                    </th>
                    <th className="text-center" style={{ width: 75 }}>
                      Sale Price
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={10}>
                      <Loading />
                    </td>
                  </tr>
                </tbody>
              </table>
            </SectionBlock>
          </div>
        </div>
      </Content>
    );
  }

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-sm-12">
          <SectionBlock title="Inventory FBL Center">
            <div className="table-responsive">
              <div className="dataTables_wrapper container-fluid dt-bootstrap4">
                <div className="row">
                  <div className="col-sm-2">
                    <Select
                      isMulti
                      classNamePrefix="form-control"
                      value={brandSelect}
                      options={
                        brand.data === undefined
                          ? []
                          : brand.data.merchantBrandList?.map((x: any) => {
                              return { value: x.id, label: x.name };
                            })
                      }
                      onChange={(e: any) => setBrandSelect(e ? e : [])}
                    />
                  </div>
                  <div className="col-sm-2">
                    <Select
                      isMulti
                      classNamePrefix="form-control"
                      value={vendorSelect}
                      options={
                        vendor.data === undefined
                          ? []
                          : vendor.data.supplierVendorList?.map((x: any) => {
                              return { value: x.id, label: x.name };
                            })
                      }
                      onChange={(e: any) => setVendorSelect(e ? e : [])}
                    />
                  </div>
                  <div className="col-sm-6"/>
                  <div className="col-sm-2 text-right">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="search..."
                      ref={inputRef}
                      onBlur={() => {
                        setSearch(inputRef.current!.value);
                      }}
                      onKeyDown={(e) =>
                        e.key === "Enter" && setSearch(inputRef.current!.value)
                      }
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <table className="table table-striped table-lightfont dataTable">
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>Image</th>
                          <th>Code</th>
                          <th className="text-center" style={{ width: 75 }}>
                            Colors
                          </th>
                          <th className="text-center" style={{ width: 75 }}>
                            Size
                          </th>
                          <th className="text-center" style={{ width: 75 }}>
                            Stock
                          </th>
                          <th className="text-center" style={{ width: 75 }}>
                            Price
                          </th>
                          <th className="text-center" style={{ width: 75 }}>
                            Discount
                          </th>
                          <th className="text-center" style={{ width: 75 }}>
                            Sale Price
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.merchantInventoryFBL.map((x: any, i: number) => {
                          return (
                            <tr key={i}>
                              <td>
                                {i + 1 + offset * 30}
                              </td>
                              <td style={{ width: 76 }}>
                                <img
                                  src={x.picture}
                                  alt=""
                                  style={{
                                    width: 50,
                                    height: 50,
                                    borderRadius: 4,
                                    objectFit: "cover",
                                  }}
                                />
                              </td>
                              <td>{x.code}</td>
                              <td className="text-center">
                                {x.colours.split(",").map((x: any) => {
                                  return (
                                    <>
                                      <sub>{x}</sub>
                                      <br />
                                    </>
                                  );
                                })}
                              </td>
                              <td className="text-center">
                                {x.size.split(",").map((x: any) => {
                                  return (
                                    <>
                                      <sub>{x}</sub>
                                      <br />
                                    </>
                                  );
                                })}
                              </td>
                              <td className="text-center">{x.stock}</td>
                              <td className="text-center" style={{ width: 75 }}>
                                <span className="text-success">
                                  ${x.saleprice}
                                </span>
                              </td>
                              <td className="text-center" style={{ width: 75 }}>
                                <span className="text-success">
                                  {Number(x.discount).toFixed(2)} %
                                </span>
                              </td>
                              <td className="text-center" style={{ width: 75 }}>
                                <span className="text-success">
                                  $
                                  {Number(
                                    Number(x.saleprice) -
                                      (Number(x.saleprice) *
                                        Number(x.discount)) /
                                        100
                                  ).toFixed(2)}{" "}
                                </span>
                              </td>
                              <td className="text-center">
                                <button
                                  className="btn btn-primary btn-sm"
                                  onClick={() => {
                                    setSku(x.sku);
                                    setShow(true);
                                  }}
                                >
                                  sku
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <nav className="text-center">
                      <PaginationOffset
                        {...props}
                        onPage={(p: any) => setOffset(p - 1)}
                      />
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </SectionBlock>
        </div>
        <Modal centered show={show} onHide={() => setShow(false)} size="lg">
          <Modal.Header
            closeButton
            translate="yes"
            onAuxClick={() => {}}
            onAuxClickCapture={() => {}}
          >
            <Modal.Title>SKU</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <table className="table table-bordered table-striped">
              <thead>
                <tr>
                  <th>Color</th>
                  <th>Size</th>
                  <th>Qty</th>
                </tr>
              </thead>
              <tbody>
                {sku.map((x: any) => {
                  return (
                    <tr key={x.sku_id}>
                      <td>{x.color}</td>
                      <td>{x.size}</td>
                      <td>{x.qty}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </Modal.Body>
        </Modal>
      </div>
    </Content>
  );
}
